import React from 'react';

import './index.css';

export default function RoleDetails(props) {
  const { roleList } = props;
  return (
    <div className='role-details' onClick={(evt)=>evt.stopPropagation()}>
      <label>Role:</label><span className="role">{roleList.join(', ')}</span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/role_components/role_details.js